import { inject } from '@angular/core';
import { HttpContextToken, HttpInterceptorFn } from '@angular/common/http';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { MaintenanceNotificationService } from './maintenance-notification.service';

export const MAINTENANCE_NOTIFICATION_SILENT = new HttpContextToken<boolean>(() => false);
export const MAINTENANCE_NOTIFICATION_SILENT_NETWORK_ERROR = new HttpContextToken<boolean>(() => false);

export const MaintenanceNotificationInterceptor: HttpInterceptorFn = (req, next) => {
	const maintenanceNotificationService = inject(MaintenanceNotificationService);

	// prettier-ignore
	return next(req).pipe(
		catchError((error) => {
			const suppressNetworkError = error.status === 0
				&& req.context.get(MAINTENANCE_NOTIFICATION_SILENT_NETWORK_ERROR);
			if (!req.context.get(MAINTENANCE_NOTIFICATION_SILENT)
				&& !suppressNetworkError
				&& [0, 408, 429, 500, 502, 503, 504].includes(error.status)) {
				maintenanceNotificationService.showMaintenanceNotification(error, req.method, req.url);
			}
			return throwError(() => error);
		})
	);
};
